import { FullscreenOverlay } from '@99designs/common/components/Fullscreen';
import React from 'react';

interface Props {
    isVisible?: boolean;
    onDismiss?(): void;
    children: React.ReactNode;
}

function RecommendationLoginModal({ isVisible = true, children }: Props) {
    if (isVisible) {
        return (
            <FullscreenOverlay
                isClosing={!isVisible}
                isActive={isVisible}
                hasOpeningAndClosingAnimation={true}
                isScrollableSmallScreens={true}
                enableScroll={false}
                variations={['raised-modal']}
            >
                <div className="fullscreen-content">{children}</div>
            </FullscreenOverlay>
        );
    }

    return null;
}

function DirectLoginModal({ isVisible = true, children }: Props) {
    if (isVisible) {
        return (
            <FullscreenOverlay
                isClosing={!isVisible}
                isActive={isVisible}
                hasOpeningAndClosingAnimation={true}
                isScrollableSmallScreens={true}
                enableScroll={false}
                variations={['solid']}
            >
                <div className="fullscreen-content fullscreen-content--centered">{children}</div>
            </FullscreenOverlay>
        );
    }

    return null;
}

export { RecommendationLoginModal, DirectLoginModal };
